import BetBody from 'modules/post/bet/bet';
import ConnectDesktop from 'modules/auth/mobile/connectDesktop';

export const investModal = {
  // title: 'Place Your Bet',
  Body: BetBody,
  maxWidth: [45, 40],
  // padding: 2,
};

export const connectDesktop = {
  Body: ConnectDesktop,
};
